module.exports = __webpack_public_path__ + "img/activity-banner1.107eab8e.png";